import TimesTableOneToSixView from './times-table-1-6'

const TimesTableSevenToTwelveView = TimesTableOneToSixView.extend({
    tables: [7, 8, 9, 10, 11, 12]
})

export default TimesTableSevenToTwelveView
